export default class {

    constructor() {
        this.init();
        this.confirmation();
    }

    init() {
        let form = document.getElementById('conference-custom');
        if (form) {
            if (typeof ajax_params !== 'undefined') {

                // ページ読み込み時にカスタム投稿のタイトルを取得してセレクトボックスに追加
                fetch(ajax_params.ajax_url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: new URLSearchParams({
                        action: 'get_conference_titles'
                    })
                })
                .then(response => response.json())
                .then(data => {
                    let preferredPlace = document.getElementById('label-for-preferred-place');
                    if (preferredPlace) {
                        preferredPlace.innerHTML = '<option value="">選択してください</option>';

                        if (data.length > 0) {
                            data.forEach(function(value) {
                                let option = document.createElement('option');
                                option.value = value.title;
                                option.dataset.id = value.id;
                                option.textContent = value.title;
                                preferredPlace.appendChild(option);
                            });
                        }
                    }
                })
                .catch(error => {
                    // console.error("Error fetching conference titles: ", error);
                });

                // 1つ目のセレクトボックスの選択が変更されたときに2つ目のセレクトボックスを更新
                let preferredPlaceSelect = document.getElementById('label-for-preferred-place');
                if (preferredPlaceSelect) {
                    preferredPlaceSelect.addEventListener('change', function() {
                        let selectedOption = this.options[this.selectedIndex];
                        let postId = selectedOption.dataset.id;

                        fetch(ajax_params.ajax_url, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            },
                            body: new URLSearchParams({
                                action: 'get_conference_dates',
                                post_id: postId
                            })
                        })
                        .then(response => response.json())
                        .then(data => {
                            let preferredDay = document.getElementById('label-for-preferred-day');
                            if (preferredDay) {
                                preferredDay.innerHTML = '<option value="">選択してください</option>';

                                if (data.length > 0) {
                                    data.forEach(function(value, index) {
                                        let option = document.createElement('option');
                                        option.value = value;
                                        option.dataset.index = index;
                                        option.textContent = value;
                                        preferredDay.appendChild(option);
                                    });
                                }
                            }
                        })
                        .catch(error => {
                            // console.error("Error fetching conference dates: ", error);
                        });

                        // 2つ目のセレクトボックスの選択が変更されたときに3つ目のセレクトボックスをリセット
                        let preferredDayReset = document.getElementById('label-for-preferred-day');
                        let preferredTimeReset = document.getElementById('label-for-preferred-time');
                        if (preferredDayReset && preferredTimeReset) {
                            preferredDayReset.innerHTML = '<option value="">選択してください</option>';
                            preferredTimeReset.innerHTML = '<option value="">選択してください</option>';
                        }
                    });
                }

                // 2つ目のセレクトボックスの選択が変更されたときに3つ目のセレクトボックスを更新
                let preferredDaySelect = document.getElementById('label-for-preferred-day');
                if (preferredDaySelect) {
                    preferredDaySelect.addEventListener('change', function() {
                        let selectedPlace = document.getElementById('label-for-preferred-place').options[document.getElementById('label-for-preferred-place').selectedIndex];
                        let postId = selectedPlace.dataset.id;
                        let dateIndex = this.options[this.selectedIndex].dataset.index;

                        fetch(ajax_params.ajax_url, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            },
                            body: new URLSearchParams({
                                action: 'get_conference_times',
                                post_id: postId
                            })
                        })
                        .then(response => response.json())
                        .then(data => {
                            let preferredTime = document.getElementById('label-for-preferred-time');
                            if (preferredTime) {
                                preferredTime.innerHTML = '<option value="">選択してください</option>';

                                if (data.times.length > 0) {
                                    let timesArray = data.times[dateIndex] ? data.times[dateIndex].split("\n") : [];
                                    timesArray.forEach(function(value) {
                                        let option = document.createElement('option');
                                        option.value = value;
                                        option.textContent = value;
                                        preferredTime.appendChild(option);
                                    });
                                }
                            }
                        })
                        .catch(error => {
                            // console.error("Error fetching conference times: ", error);
                        });
                    });
                }
            }
        }
    }
    confirmation() {
        // 確認画面用の処理
        let formConfirm = document.querySelector('#conference-custom .mw_wp_form_confirm');
        if (formConfirm) {
            let preferredPlaceValue = document.querySelector('input[name="preferred-place"]').value;
            let preferredDayValue = document.querySelector('input[name="preferred-day"]').value;
            let preferredTimeValue = document.querySelector('input[name="preferred-time"]').value;
    
            let confirmationPreferredPlace = document.getElementById('confirmation-preferred-place');
            let confirmationPreferredDay = document.getElementById('confirmation-preferred-day');
            let confirmationPreferredTime = document.getElementById('confirmation-preferred-time');
    
            if (confirmationPreferredPlace && confirmationPreferredDay && confirmationPreferredTime) {
                let spanPreferredPlace = confirmationPreferredPlace.querySelector('span') || document.createElement('span');
                let spanPreferredDay = confirmationPreferredDay.querySelector('span') || document.createElement('span');
                let spanPreferredTime = confirmationPreferredTime.querySelector('span') || document.createElement('span');
    
                spanPreferredPlace.textContent = preferredPlaceValue;
                spanPreferredDay.textContent = preferredDayValue;
                spanPreferredTime.textContent = preferredTimeValue;
    
                if (!confirmationPreferredPlace.contains(spanPreferredPlace)) {
                    confirmationPreferredPlace.appendChild(spanPreferredPlace);
                }
                if (!confirmationPreferredDay.contains(spanPreferredDay)) {
                    confirmationPreferredDay.appendChild(spanPreferredDay);
                }
                if (!confirmationPreferredTime.contains(spanPreferredTime)) {
                    confirmationPreferredTime.appendChild(spanPreferredTime);
                }
    
                // console.log('Values have been set in confirmation page');
            }
        }
    }    
}
